import { Component, OnInit, Input } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { MatDialogRef } from '@angular/material';

import { SessionStorageService } from '../../core/index.service';

@Component({
    selector: 'shared-userinfo',
    templateUrl: './userinfo.component.html'
})
export class UserInfoComponent implements OnInit {

    constructor(
        private router: Router,
        private storageService: SessionStorageService,
        public dialogRef: MatDialogRef<UserInfoComponent>
    ) { }

    ngOnInit() { }

    closeModal(): void {
        this.dialogRef.close();
    }

    logOut() {
        this.storageService.logOut();
        this.dialogRef.close();
        let link = ['home'];
        this.router.navigate(link);
    }


}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/login/userinfo.component.ts